"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LambdasClient = void 0;
const dcl_catalyst_commons_1 = require("dcl-catalyst-commons");
const Helper_1 = require("./utils/Helper");
class LambdasClient {
    constructor(lambdasUrl, fetcher) {
        this.lambdasUrl = Helper_1.sanitizeUrl(lambdasUrl);
        this.fetcher =
            fetcher !== null && fetcher !== void 0 ? fetcher : new dcl_catalyst_commons_1.Fetcher({
                headers: Helper_1.getHeadersWithUserAgent('lambdas-client')
            });
    }
    fetchProfiles(ethAddresses, profileOptions, options) {
        const queryParams = new Map();
        queryParams.set('id', ethAddresses);
        if (profileOptions === null || profileOptions === void 0 ? void 0 : profileOptions.fields) {
            const fieldsValue = profileOptions === null || profileOptions === void 0 ? void 0 : profileOptions.fields.getFields();
            queryParams.set('fields', [fieldsValue]);
        }
        return Helper_1.splitAndFetch({
            fetcher: this.fetcher,
            baseUrl: this.lambdasUrl,
            path: '/profiles',
            queryParams,
            options
        });
    }
    fetchWearables(filters, options) {
        const queryParams = Helper_1.convertFiltersToQueryParams(filters);
        if (queryParams.size === 0) {
            throw new Error('You must set at least one filter');
        }
        return Helper_1.splitAndFetchPaginated({
            fetcher: this.fetcher,
            baseUrl: this.lambdasUrl,
            path: '/collections/wearables',
            queryParams,
            uniqueBy: 'id',
            elementsProperty: 'wearables',
            options
        });
    }
    fetchOwnedWearables(ethAddress, includeDefinitions, options) {
        return Helper_1.splitAndFetch({
            fetcher: this.fetcher,
            baseUrl: this.lambdasUrl,
            path: `/collections/wearables-by-owner/${ethAddress}`,
            queryParams: { name: 'includeDefinitions', values: [`${includeDefinitions}`] },
            options
        });
    }
    fetchCatalystsApprovedByDAO(options) {
        return this.fetcher.fetchJson(`${this.lambdasUrl}/contracts/servers`, options);
    }
    fetchLambdasStatus(options) {
        return this.fetcher.fetchJson(`${this.lambdasUrl}/status`, options);
    }
    getLambdasUrl() {
        return this.lambdasUrl;
    }
}
exports.LambdasClient = LambdasClient;
//# sourceMappingURL=LambdasClient.js.map